import { apiClient, isApiError } from './apiClient';
import { ISpecialAlertCondition } from '../types/PropertyTypes';

interface SpecialAlertConditionListResponse {
  data: ISpecialAlertCondition[];
}

interface SpecialAlertConditionSingleResponse {
  data: ISpecialAlertCondition;
}

interface ValidationErrorResponse {
  errors: Record<string, string[]>;
}

/**
 * 特別条件一覧を取得
 */
export async function getList(): Promise<ISpecialAlertCondition[]> {
  const result = await apiClient.get<SpecialAlertConditionListResponse>('/special-alert-conditions');
  return Array.isArray(result.data) ? result.data : [];
}

/**
 * 特別条件の詳細を取得
 */
export async function getById(id: number): Promise<ISpecialAlertCondition> {
  const result = await apiClient.get<SpecialAlertConditionSingleResponse>(`/special-alert-conditions/${id}`);
  return result.data;
}

/**
 * 特別条件を作成
 */
export async function create(data: Record<string, unknown>): Promise<{ data?: ISpecialAlertCondition; validationErrors?: Record<string, string[]> }> {
  try {
    const result = await apiClient.post<SpecialAlertConditionSingleResponse>('/special-alert-conditions', data);
    return { data: result.data };
  } catch (error) {
    if (isApiError(error) && error.status === 422 && error.data) {
      return { validationErrors: (error.data as unknown as ValidationErrorResponse).errors };
    }
    throw error;
  }
}

/**
 * 特別条件を更新
 */
export async function update(id: number, data: Record<string, unknown>): Promise<{ data?: ISpecialAlertCondition; validationErrors?: Record<string, string[]> }> {
  try {
    const result = await apiClient.put<SpecialAlertConditionSingleResponse>(`/special-alert-conditions/${id}`, data);
    return { data: result.data };
  } catch (error) {
    if (isApiError(error) && error.status === 422 && error.data) {
      return { validationErrors: (error.data as unknown as ValidationErrorResponse).errors };
    }
    throw error;
  }
}

/**
 * 特別条件を削除
 */
export async function del(id: number): Promise<void> {
  return apiClient.del(`/special-alert-conditions/${id}`);
}

/**
 * アクティブ状態の切り替え
 */
export async function toggleActive(id: number): Promise<ISpecialAlertCondition> {
  return apiClient.post<ISpecialAlertCondition>(`/special-alert-conditions/${id}/toggle-active`, {});
}
